export type TypePriority = '' | 'important';

// ----------------------------------------------------------------------------

function setStyle(element: HTMLElement, key: string, value: string, priority: TypePriority = ''): void {
    const property = key.replace(/([A-Z])/g, '-$1').toLowerCase();

    element.style.setProperty(property, value, priority);
}

// ----------------------------------------------------------------------------

export default setStyle;
